/** *****************************Actions************************* */
export const Action = {
  CREATE: 'create',
  LIST: 'list',
  GET: 'get',
  UPDATE: 'update',
  DELETE: 'delete',
  DOWNLOAD: 'download',
  STATUS_UPDATE: 'statusupdate',
  UPLOAD_ATTACHMENT: 'uploadAttachment',
  CREATE_COMMENT: 'createComment',
  DOWNLOAD_ATTACHMENT: 'downloadAttachment',
  LIST_COMMENT: 'listComment',
  GET_COMMENT: 'getComment',
  UPLOAD_COMMENT_ATTACHMENT: 'uploadCommentAttachment',
  DOWNALOD_COMMENT_ATTACHMENT: 'downloadCommentAttachment',
  APPROVER: 'approver',
  TOGGLE_USER_STATUS :'toggleUserStatus',
  LIST_MISSING_FINCAID:'listMissingFincaId',
  LIST_COUNTRIES:'listCountries',
  LIST_ROAMING_PARTNERS:'listRoamingPartners',
  EDIT_VOLTE_DEMAND:'editVolteDemand',
  LISTALL:'listAll',
  /*----------------D2C-----------------*/
  REVIEW_DEMAND:"reviewDemand",
  CREARE_FEASIBILITY:"createFeasibility",
  GET_FEASIBILITY_DETAILS:"getFeasibilityDetails",
  DOWNLOAD_FEASIBILITY_REPORT:"downloadFeasibilityReport",
  CREARE_FLOORPRICING:"createFloorPricing",
  SERVICE_PROVISIONING_INITIATOR:"serviceProvisioningInitiator",
  CREATE_SERVICE_PROVISIONING:"createServiceProvisioning",
  CREATE_PROVISIONING_COMMENTS:"createProvisioningComments",
  CREATE_BILLING:"createBilling",
  GET_BILLING_DETAILS:"getBillingDetails",
  COMPLETE_DEMAND:"completeDemand",
  GET_SIGNED_ORDERFORM_DETAILS:"getSignedOrderFormDetails",
  DOWNLOAD_SIGNED_ORDERFORM:"downloadSignedOrderFormAttachments",
  GET_SERVICE_PROVISIONING_DETAILS:"getServiceProvisioningDetails",
  DOWNLOAD_SERVICE_PROVISIONING:"downloadServiceProvisioningDetailsAttachments",
  UPLOAD_ORDERFORM_LEAGAL_CONTARCT_ATTACHMENT:"uploadOrderFormLegalContractAttachments",
  GET_ORDERFORM_LEAGAL_CONTARCT_DETAILS:"getOrderFormLegalContractDetails",
  CREATE_FEASIBILITY_COMMENTS:"createFeasibilityComments",
  GET_FLOORPRICE_DETAILS:"getFloorPricingDetails",
  GET_QUOTATION_DETAILS:"getQuotationDetails",
  // CREATE_FLOORPRICE:"createFloorPricing",
  CREATE_ADD_MARGIN:"createQuotationMargin",
  CREATE_DRAFT_ORDER_FORM:"createDraftOrderForm",
  GET_DRAFT_ORDER_DETAILS:"getDraftOrderFormDetails",
  TRIGGER_ORDERFORM_CONTACT_EMAIL:"triggerOrderFormLegalContractEmail",
  DOWNLOAD_LEGAL_CONTRACT:"downloadOrderFormLegalContractAttachments",
  CLOSER:"closer",
  CREATE_SIGNED_ORDERFORM:"createSignedOrderForm",
  APPROVE_QUOTATION:"approveQuotation",
  CREATE_UNSIGNED_ORDERFORM:"createUnsignedOrderForm",
  UPLOAD_SIGNED_ORDERFORM_ATTACHMENTS:"uploadSignedOrderFormAttachments",
  LIST_ACTIVITY:"listActivity",
  GET_FEASIBILITY_COMMENT:"getFeasibilityComments",
  GET_PROVISIONING_COMMENT:"getProvisioningComments",
  DOWNLOAD_FLOORPRICE_PDF:"downloadFloorPricingAttachments",
  DOWNLOAD_QUOTATION_PDF:"downloadQuotationAttachments"
};

/** *****************************Resources************************* */
export const Resource = {
  IPX_POP: "ipxPoP",
  LIVE_SERVICES: "liveServices",
  DEMANDS: "demands",
  CUSTOMER_NAMES: 'customerNames',
  DIAMETER: "diameter",
  SIGTRAN: "sigtran",
  WEATHERMAPS: "weathermaps",
  QUERY: "query",
  INCIDENTS: "incidents",
  SERVICE_REQUESTS: "serviceRequests",
  CUSTOMERS:"customers",
  EMAIL_VERIFICATION_LINK: 'emailVerificationLink',
  FUNCTIONAL_ROLES: 'functionalRoles',
  RIGHTS: 'rights',
  CUSTOMER_ONBOARDING_REQUEST: 'customerOnboardingRequest',
  CUSTOMER_ACCESSR_REQUEST: 'customerAccessRequest',
  SERVICE_LOCATIONS: "serviceLocations",
  SERVICE_TYPE: "serviceType",
  CUSTOMER_ONBOARDING_APPROVAL:"customerOnboardingApproval",
  CUSTOMER_ACCESS_APPROVAL:"customerAccessApproval",
  FINCAINVOICE:"fincaInvoice",
  FINCA_TADIG:"fincaTADIG",
  MISSING_ONEITSM_SERVICE_CUSTOMERS: 'missingOneITSMServiceCustomers',
  BROADCAST_NOTIFICATIONS:'broadcastNotifications',
  REGULATORY:'regulatory',
  DASHBOARD_WIDGETS:'dashboardWidgets',
  FILTER_CUSTOMERS:'filtercustomers',
  RIGHTS_REPORT:'rightsReport',
  D2C_DEMANDS:"d2cDemands",
};

